export const permissoesRotas = {
  // Relatorio de Acompanhamento
  criaRelAcomp: ['cria_rel_acomp'],
  downloadRelAcomp: ['downl_rel_acomp'],
  retificaRelatorios: ['retif_rel_acomp'],
  assinaturaFinalRelAcomp: ['assin_rel_acomp'],
  relAcompEnviados: ['get_rel_acomps'],
  //  Pendências
  respondePendencia: ['resp_pend'],
  acompanhaPendencias: [],
  //  Indicadores
  informaIndicador: ['informa_indic'],
  ajustaIndicador: ['ajusta_indic'],
  // Admin
  configuracoesGerais: [],
  // Relatórios
  gerarRelatorios: ['gera_relatorios'],
  // // Testes
  // testes: [],
};